export default {
    data: function() {
        return {
            type: 'single',
            mobileType: 'single',
            useMobileSettings: false,
            sizeOption: {
                type: 'scale',
                mobileType: 'scale',
                ratio: 33.33,
                mobileRatio: 66.7,
                height: 300,
                mobileHeight: 300
            },
            bgColor: '',
            mobileBgColor: '',
            pictureOption: {
                src: ''
            },
            mobilePicture: '',
            pictureListOption: {
                list: [],
                mobileList: [],
                showPagination: false,
                swiperOption: {}
            },
            mobilePictureListOption: {
                list: [],
                showPagination: false,
                swiperOption: {}
            },
            maskOption: {
                showMask: true,
                maskColor: 'rgba(0,0,0,0.15)',
                maskOpacity: 1
            },
            videoOption: {
                autoplay: true,
                src: '',
                previewSrc: '',
                playInline: false,
                showProgress: false,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: false,
                volume: null,
                videoLoop: false
            },
            mobileVideoOption: {
                autoplay: false,
                src: '',
                previewSrc: '',
                playInline: false,
                showProgress: true,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: false,
                volume: null,
                videoLoop: false
            }
        };
    }
};
